import { Chip } from '@mui/material';
import React from 'react';
import { pickStatusColor } from '../../../utils/appConstants';

const TableOrderStatus = ({ row, col, value }) => {
  return (
    <div>
      <Chip label={value} color={pickStatusColor?.[value] ?? 'primary'} />
    </div>
  );
};

export default TableOrderStatus;
